import React, { memo } from 'react'
import { ApfFieldsResponse } from 'orders/ordersService'
import ApfRow from './apfRow'
import { prepareCustomerInfoFields } from '../utils/prepareCustomerInfoFields'
import '../styles.scss'
import { CustomerInfoValue } from '../types'

interface CustomerInfoDetailsProps {
    value: CustomerInfoValue
    apfFieldsKey: ApfFieldsResponse
    shouldHideBuyerEmail: boolean
    shouldHideFieldsExceptBuyerEmail: boolean
}

const CustomerInfoDetails: React.FC<CustomerInfoDetailsProps> = ({
    value,
    apfFieldsKey,
    shouldHideBuyerEmail,
    shouldHideFieldsExceptBuyerEmail,
}) => {
    const { defaultFields, customFields, hasVisibleFields } = React.useMemo(() => {
        return prepareCustomerInfoFields(
            value,
            apfFieldsKey,
            shouldHideBuyerEmail,
            shouldHideFieldsExceptBuyerEmail
        )
    }, [value, apfFieldsKey, shouldHideBuyerEmail, shouldHideFieldsExceptBuyerEmail])

    if (!hasVisibleFields) {
        return null
    }

    return (
        <div className="customer-info">
            {defaultFields.map(({ key, label, value }) => (
                <ApfRow key={key} label={label} value={value} />
            ))}
            {customFields.map(({ key, label, value }) => (
                <ApfRow key={key} label={label} value={value} />
            ))}
        </div>
    )
}

export default memo(CustomerInfoDetails)
